import Swiper, { Navigation, Pagination, EffectFade, Autoplay, Thumbs, Lazy } from "swiper"

Swiper.use([Navigation, Pagination, EffectFade, Autoplay, Thumbs, Lazy])

"use strict";

import oneHeightElements from './one-height'

$(window).on('load resize', function(){
	oneHeightElements($('.compare-card__top'))
	oneHeightElements($('.compare-card__list-title'))
	oneHeightElements($('.compare-card__item-label'))
	oneHeightElements($('.compare-card__item-text'))
});

document.addEventListener("DOMContentLoaded", () => {
	window.initCompare();
});

window.initCompare = () => {
	// compare-slider
	let compareSliders = document.querySelectorAll('.compare-slider__cont');
	let compareSliderSwiper;
	
	compareSliders.forEach((slider) => {
		compareSliderSwiper = new Swiper(slider.querySelector('.compare-slider'), {
			slidesPerView: 2,
			spaceBetween: 0,
			// slidesPerView: 'auto',
			lazy: {
				loadPrevNext: true,
			},
			pagination: {
				el: slider.querySelector('.swiper-pagination'),
				type: 'fraction',
			},
			navigation: {
				nextEl: slider.querySelector('.swiper-button-next'),
				prevEl: slider.querySelector('.swiper-button-prev'),
			},
			breakpoints: {
				1000: {
					slidesPerView: 4,
				},
				720: {
					slidesPerView: 3,
				},
				520: {
					slidesPerView: 2,
				},
				// 420: {
				// 	slidesPerView: 1,
				// }
			}
		});

		if($(window).width() >= 1000) {
			if(slider.querySelectorAll('.compare-slider__item').length <=4){
				slider.querySelector('.swiper-controls').remove();
			}
	
		} else if($(window).width() >=720) {
			if(slider.querySelectorAll('.compare-slider__item').length <=3){
				slider.querySelector('.swiper-controls').remove();
			}
		} else if($(window).width() >=520) {
			if(slider.querySelectorAll('.compare-slider__item').length <=2){
				slider.querySelector('.swiper-controls').remove();
			}
		} 
		// else if($(window).width() >=420) {
		// 	if(slider.querySelectorAll('.compare-slider__item').length <=1){
		// 		slider.querySelector('.swiper-controls').remove();
		// 	}
		// } else if($(window).width() < 420) {
		// 	if(slider.querySelectorAll('.compare-slider__item').length <=1){
		// 		slider.querySelector('.swiper-controls').remove();
		// 	}
		// }

	});

}
